import { useAppDispatch, useAppSelector, userApi } from 'app/store';
import { User } from 'features/profile/types/user.types';

const useProfile = () => {
    const dispatch = useAppDispatch();

    const { data: profile }: { data?: User } = useAppSelector(
        userApi.endpoints.userProfile.select(),
    );

    const update = (profile: User) => {
        dispatch(
            userApi.util.updateQueryData('userProfile', undefined, () => {
                return profile;
            }),
        );
    };

    return { profile, update };
};

export default useProfile;
